/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Paper from '@material-ui/core/Paper';

export default function PaperObjectField(props) {
  const { registry } = props;
  const ObjectField = registry?.fields?.ObjectField;
  return (
    <Paper className={props?.formContext?.classes?.paper}>
      <ObjectField {...props} />
    </Paper>
  );
}
